import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Card } from '@/components/ui/card';

export const LeadTab = ({ formData, handleChange, handleSelectChange }) => {
  return (
    <Card className="p-6 sm:p-10 bg-white/80 backdrop-blur-xl border-2 border-slate-100 rounded-3xl shadow-xl">
      <h2 className="text-2xl sm:text-3xl font-heading font-bold text-slate-900 mb-8">Lead Information</h2>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8">
        <div>
          <Label className="text-sm font-semibold text-slate-700 mb-3 block">Lead Source *</Label>
          <Select value={formData.leadSource} onValueChange={(v) => handleSelectChange('leadSource', v)}>
            <SelectTrigger data-testid="select-lead-source" className="h-12 rounded-xl"><SelectValue placeholder="Select source" /></SelectTrigger>
            <SelectContent>
              <SelectItem value="meta">Meta (Facebook/Instagram)</SelectItem>
              <SelectItem value="google">Google Ads</SelectItem>
              <SelectItem value="social_media">Social Media</SelectItem>
              <SelectItem value="word_of_mouth">Word of Mouth</SelectItem>
              <SelectItem value="referral">Referral</SelectItem>
              <SelectItem value="walk_in">Walk In</SelectItem>
              <SelectItem value="website">Website</SelectItem>
              <SelectItem value="email_campaign">Email Campaign</SelectItem>
              <SelectItem value="trade_show">Trade Show / Event</SelectItem>
            </SelectContent>
          </Select>
        </div>
        
        <div>
          <Label className="text-sm font-semibold text-slate-700 mb-3 block">Lead Generated Date</Label>
          <Input name="leadGeneratedDate" data-testid="input-lead-date" type="date" value={formData.leadGeneratedDate} onChange={handleChange} className="h-12 rounded-xl" />
        </div>
        
        {formData.leadSource === 'referral' && (
          <div className="md:col-span-2 animate-fade-in">
            <Label className="text-sm font-semibold text-slate-700 mb-3 block">Referred By</Label>
            <Input name="referredBy" data-testid="input-referred-by" value={formData.referredBy} onChange={handleChange} placeholder="Name of referrer" className="h-12 rounded-xl" />
          </div>
        )}
      </div>
    </Card>
  );
};
